// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerText":"Footer_footerText__y-wf5"};